import React from "react";
import HelpCenterImg from "../../assets/images/help-center-img.png";
import HelpCenterTopics from "./HelpCenterTopicsCard/HelpCenterTopicsCard";
import HelpCenterFaq from "./HelpCenterFaqs/HelpCenterFaqs";
// Help Topics Array
const helpTopics = [
  {
    icon: "bi-person-circle",
    title: "Account & notifications",
    description: "Account settings, login issues, and notification preferences",
  },
  {
    icon: "bi-credit-card",
    title: "Payments & subscriptions",
    description: "Help with payments, subscription options, and Financial Aid",
  },
  {
    icon: "bi-journal-text",
    title: "Enrollment",
    description: "Find courses to take and learn about enrollment options",
  },
  {
    icon: "bi-pencil-square",
    title: "Grades & assignments",
    description: "Grades, peer reviews, assignments, and Labs",
  },
  {
    icon: "bi-patch-check",
    title: "Certificates & verification",
    description: "How to get and share a Course Certificate",
  },
  {
    icon: "bi-shield-check",
    title: "Coursera policies",
    description: "Learn about our policies and program terms",
  },

    {
    icon: "bi-pencil-square",
    title: "Course content",
    description: "Videos, discussion forums, and common course issues",
  },
  {
    icon: "bi-patch-check",
    title: "Specializations",
    description: "Help with Specializations and Capstone Projects",
  },
  {
    icon: "bi-shield-check",
    title: "Degrees & other programs",
    description: "Help with degrees, Professional Certificates, and other programs",
  },
];
// FAQs Array
const InitialFaqItems = [
  {
    id: 1,
    question: "Is there a free trial available?",
    answer:
      "Yes, You Can Try Us For Free For 30 Days. If You Want, We'll Provide You With A Free, Personalized 30-Minute Onboarding Call To Get You Up And Running As Soon As Possible.",
    show: true,
  },
  {
    id: 2,
    question: "Can I change my plan later?",
    answer: "Yes, you can change your plan anytime from your account settings.",
    show: false,
  },
  {
    id: 3,
    question: "What is your cancellation policy?",
    answer:
      "You can cancel your subscription at any time. Your access will remain until the end of your billing period.",
    show: false,
  },
  {
    id: 4,
    question: "How does billing work?",
    answer: "We bill monthly or annually depending on the plan you select.",
    show: false,
  },
  {
    id: 5,
    question: "Can other info be added to an invoice?",
    answer:
      "Yes, you can include extra details like tax info or company address in your invoice settings.",
    show: false,
  },
  {
    id: 6,
    question: "How do I change my account email?",
    answer:
      "Go to your profile settings and update your email address. A confirmation will be sent to the new address.",
    show: false,
  },
];

const HelpCenterComponent = () => {
  return (
    <>
      <div className="card-default-style px-10 px-sm-20 px-md-30 px-lg-50 py-10 py-sm-15 py-md-20 py-lg-30">
        <div className="help-center text-center">
          <img
            src={HelpCenterImg}
            className="img-fluid mx-auto"
            alt="Question Marks"
          />
          <h2 className="fw-bold my-21 ah-heading-01">Help Center</h2>

          <div className="help-search-box-wrapper mx-auto mt-22 overflow-hidden px-9 py-0">
            <div className="position-relative">
              <input
                type="text"
                className="form-control pe-50"
                placeholder="Search for Help..."
              />
              <span className="icon-search position-absolute cursor-pointer"></span>
            </div>
          </div>

          <HelpCenterTopics helpTopicsList={helpTopics} />
          <div className="mt-10 mt-sm-20 mt-md-30 mt-lg-40">
            <h3 className="text-start mb-20 ah-heading-04 fw-bold">
              Popular Articles
            </h3>
            <div className="faqs-section p-0">
              <HelpCenterFaq FaqItemsList={InitialFaqItems} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpCenterComponent;
